import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";
import { useSelector } from "react-redux";
import { utilsState } from "../../../sotre/redux/features/utilsSlice";

const { forwardRef, useRef, useImperativeHandle } = React;

const CategoryPartType = forwardRef(({ oldData, onChange, label }, ref) => {
  const [data, setdata] = useState([]);
  const [categoriesOption, setCategoriesOption] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const { utils } = useSelector(utilsState);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedCategories([]);
      getCategory();
    },
  }));

  const getCategory = async () => {
    setdata(utils?.CATEGORY_PART_TYPE_VALUES);
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    let newCategory = [];
    data?.map((item) =>
      newCategory.push({
        value: item.value,
        label: item.name,
      })
    );
    setCategoriesOption(newCategory);
  }, [data]);

  function handleCategory(data) {
    setSelectedCategories(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  useEffect(() => {
    if (oldData?.length) {
      let selectedCategories = [];
      oldData.forEach((element) => {
        selectedCategories.push({
          value: element,
          label: utils?.CATEGORY_PART_TYPE[element]?.name,
        });
      });

      setSelectedCategories(selectedCategories);
    }
  }, [oldData, data]);

  return (
    <div>
      {label ? (
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
      ) : null}
      <Select
        classNamePrefix="admin-select"
        isRtl
        className=""
        options={categoriesOption}
        placeholder="انتخاب دسته بندی"
        value={selectedCategories}
        onChange={handleCategory}
        isSearchable={true}
        isMulti
      />
    </div>
  );
});

export default CategoryPartType;
